import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getApiBaseUrl } from './api-base-url';
import { AppInfoVersionResponse } from '../models/app-info.model';

@Injectable({ providedIn: 'root' })
export class AppInfoApiService {
  private readonly http = inject(HttpClient);
  private readonly apiBaseUrl = getApiBaseUrl();

  getVersion(): Observable<AppInfoVersionResponse> {
    return this.http.get<AppInfoVersionResponse>(`${this.apiBaseUrl}app-info/version`);
  }
}
